import * as i0 from '@angular/core';
import { input, signal, effect, Component, ChangeDetectionStrategy, Injectable } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgComponentOutlet } from '@angular/common';
import { NgxIcon } from '@digipay/ngx-icon';
import { Subject } from 'rxjs';
const _forTrack0 = ($index, $item) => $index + $item.accordionTitle;
function NgxAccordionComponent_For_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-icon", 4);
  }
  if (rf & 2) {
    const config_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", config_r4.accordionTitle)("type", "linear")("iconSize", "20");
  }
}
function NgxAccordionComponent_For_2_Conditional_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NgxAccordionComponent_For_2_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, NgxAccordionComponent_For_2_Conditional_8_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const config_r4 = ctx_r4.$implicit;
    const $index_r2 = ctx_r4.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@showDetails", undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngComponentOutlet", config_r4.component)("ngComponentOutletInputs", ctx_r2.inputsToPass()[$index_r2]);
  }
}
function NgxAccordionComponent_For_2_Conditional_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NgxAccordionComponent_For_2_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, NgxAccordionComponent_For_2_Conditional_9_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const config_r4 = ctx_r4.$implicit;
    const $index_r2 = ctx_r4.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@showDetails", undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngComponentOutlet", config_r4.component)("ngComponentOutletInputs", ctx_r2.inputsToPass()[$index_r2]);
  }
}
function NgxAccordionComponent_For_2_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
  }
}
function NgxAccordionComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
    i0.ɵɵlistener("click", function NgxAccordionComponent_For_2_Template_div_click_2_listener() {
      const $index_r2 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleDetails($index_r2));
    });
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵtemplate(4, NgxAccordionComponent_For_2_Conditional_4_Template, 1, 3, "ngx-icon", 4);
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "ngx-icon", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, NgxAccordionComponent_For_2_Conditional_8_Template, 2, 3, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, NgxAccordionComponent_For_2_Conditional_9_Template, 2, 3, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, NgxAccordionComponent_For_2_Conditional_10_Template, 1, 0, "div", 8);
  }
  if (rf & 2) {
    const config_r4 = ctx.$implicit;
    const $index_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(4, config_r4.accordionTitle !== "" ? 4 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(config_r4.accordionTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("@rotateChevron", ctx_r2.showDetails()[$index_r2] ? "open" : "close")("name", "Arrow-2-down")("type", "linear")("classes", "text-onback-medium")("iconSize", "20");
    i0.ɵɵadvance();
    i0.ɵɵconditional(8, !ctx_r2.showDetails()[$index_r2] ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(9, ctx_r2.showDetails()[$index_r2] ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(10, config_r4.showDivider ? 10 : -1);
  }
}
let NgxAccordionComponent = /*#__PURE__*/(() => {
  class NgxAccordionComponent {
    constructor() {
      // Inputs
      this.configs = input.required();
      this.multipleOpen = input(false);
      this.wrapperClasses = input();
      // Models
      this.showDetails = signal([]);
      // Variables
      this.inputsToPass = signal([]);
      effect(() => {
        if (this.configs().length) {
          this.initData();
        }
      }, {
        allowSignalWrites: true
      });
    }
    initData() {
      this.showDetails.set([]);
      const booleans = [];
      const inputs = [];
      this.configs().forEach(config => {
        booleans.push(config.isOpen);
        inputs.push({
          ...config.inputs,
          isOpen: config.isOpen
        });
      });
      this.showDetails.set(booleans);
      this.inputsToPass.set(inputs);
    }
    toggleDetails(index) {
      if (this.multipleOpen()) {
        const modifiedBooleans = this.showDetails();
        const modifiedInputs = this.inputsToPass();
        modifiedBooleans[index] = !modifiedBooleans[index];
        modifiedInputs[index] = {
          ...modifiedInputs[index],
          isOpen: !modifiedInputs[index]['isOpen']
        };
        this.showDetails.set(modifiedBooleans);
      } else {
        const booleans = [];
        const inputs = [];
        this.showDetails().forEach((config, i) => {
          const boolean = i === index ? !this.showDetails()[index] : false;
          booleans.push(boolean);
          inputs.push({
            ...this.inputsToPass()[i],
            isOpen: boolean
          });
          return boolean;
        });
        this.showDetails.set(booleans);
        this.inputsToPass.set(inputs);
      }
    }
    static {
      this.ɵfac = function NgxAccordionComponent_Factory(t) {
        return new (t || NgxAccordionComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxAccordionComponent,
        selectors: [["ngx-accordion"]],
        inputs: {
          configs: [i0.ɵɵInputFlags.SignalBased, "configs"],
          multipleOpen: [i0.ɵɵInputFlags.SignalBased, "multipleOpen"],
          wrapperClasses: [i0.ɵɵInputFlags.SignalBased, "wrapperClasses"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 2,
        consts: [[1, "d-flex", "flex-column"], [1, "accordion-title", "d-flex", "flex-column"], [1, "d-flex", "flex-row", "justify-content-space-between", "align-items-center", "w-100", "pb-low", "cursor-pointer", 3, "click"], [1, "d-flex", "gap-low", "align-items-center"], [3, "name", "type", "iconSize"], [3, "name", "type", "classes", "iconSize"], [1, "d-flex", "flex-row", "flex-wrap"], [1, "accordion-details", "w-100"], [1, "w-100", "my-plus", "border-b-300", "border-color-air"], [4, "ngComponentOutlet", "ngComponentOutletInputs"]],
        template: function NgxAccordionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵrepeaterCreate(1, NgxAccordionComponent_For_2_Template, 11, 10, null, null, _forTrack0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap("d-flex flex-column " + ctx.wrapperClasses());
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.configs());
          }
        },
        dependencies: [NgComponentOutlet, NgxIcon],
        styles: [".accordion-title[_ngcontent-%COMP%], .accordion-details[_ngcontent-%COMP%]{overflow:hidden}"],
        data: {
          animation: [trigger('showDetails', [state('void', style({
            height: 0
          })), state('*', style({
            height: '*'
          })), transition('void <=> *', [animate('0.2s')])]), trigger('rotateChevron', [state('close', style({
            rotate: '0deg'
          })), state('open', style({
            rotate: '180deg'
          })), transition('open <=> close', [animate('0.2s')])])]
        },
        changeDetection: 0
      });
    }
  }
  return NgxAccordionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccordionStateService = /*#__PURE__*/(() => {
  class AccordionStateService {
    constructor() {
      this.componentState = new Map();
      this.clearStateHappened = new Subject();
    }
    // Save state for a component
    saveState(componentId, state) {
      this.componentState.set(componentId, state);
    }
    // Retrieve state for a component
    getState(componentId) {
      return this.componentState.get(componentId);
    }
    // Clear state for a component
    clearState(componentId) {
      this.componentState.delete(componentId);
    }
    // Clear states for a list of components
    bulkClearState(componentIds) {
      componentIds.forEach(id => this.componentState.delete(id));
      this.clearStateHappened.next(componentIds);
    }
    static {
      this.ɵfac = function AccordionStateService_Factory(t) {
        return new (t || AccordionStateService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AccordionStateService,
        factory: AccordionStateService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AccordionStateService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-accordion
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionStateService, NgxAccordionComponent };
